module.exports = __webpack_public_path__ + "static/media/mz.652e7d4e.svg";